import Vue from "vue";
import Vuex from "vuex";
import ApiV2 from "../services/ApiV2";
import Api from "../services/Api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    table: "",
    user: {},
    data: [],
    permissions: [],
    editInDialog: true,
    school: {},
    schoolFieldId: null,
    countries: [],
    currentRole: {},
    enrolledStudent: {},
    schoolClassId: 0,
  },
  getters: {
    getEducationalFields: (state) => {
      return state.school?.educational_fields;
    },
    getUser: (state) => {
      return state.user;
    },
    getSchool: (state) => {
      return state.school;
    },
    getCountryByValue: (state) => (value) => {
      return state.countries.find((country) => {
        return country.value == value;
      });
    },
    getSchoolFieldId: (state) => {
      return state.schoolFieldId;
    },
    getCurrentRole: (state) => {
      return state.currentRole;
    },
    getEnrolledStudent: (state) => {
      return state.enrolledStudent;
    },
    getSchoolClassId: (state) => {
      return state.schoolClassId;
    },
  },
  mutations: {
    setTable(state, table) {
      state.table = table;
    },

    setUser(state, user) {
      state.user = user;
    },

    setPermissions(state, permissions) {
      state.permissions = permissions;
    },

    setData(state, data) {
      state.data = data;
    },

    setEditInDialog(state, editInDialog) {
      state.editInDialog = editInDialog;
    },

    setSchool: (state, school) => {
      state.school = school;
    },

    setCountries: (state, countries) => {
      state.countries = countries;
    },

    setSchoolFieldId(state, schoolFieldId) {
      state.schoolFieldId = schoolFieldId;
    },

    setCurrentRole(state, currentRole) {
      state.currentRole = currentRole;
    },

    setEnrolledStudent(state, enrolledStudent) {
      state.enrolledStudent = enrolledStudent;
    },
    setSchoolClassId(state, schoolClassId) {
      state.schoolClassId = schoolClassId;
    }
  },
  actions: {
    async getUser({commit}){
      let {data} = await Api.post("prijavljeni")
      commit("setUser", data);
    },
    async getSchool({ commit }, payload) {
      let schoolId = payload;

      if (schoolId === undefined)
        schoolId = parseInt(localStorage.getItem("school_id"));

      if (schoolId > 0)
        ApiV2.get(`schools/${schoolId}`, {
          params: {
            with: ["educationalFields", "headmaster", "canton"],
          },
        }).then((response) => {
          if (response.status === 200) {
            commit("setSchool", response.data);
          }
        });
      else commit("setSchool", null);
    },
    async getCountries({ commit }) {
      Api.get("ostalo/drzave").then((response) => {
        if (response.status === 200) {
          commit("setCountries", response.data);
        }
      });
    },

    setSchoolFieldId({ commit }, payload) {
      commit("setSchoolFieldId", payload);
    },

    setCurrentRole({ commit }, payload) {
      commit("setCurrentRole", payload);
    },

    setUser({ commit }, payload) {
      commit("setUser", payload);
    },

    setSchoolClassId({ commit }, payload) {
      commit("setSchoolClassId", payload);
    },

    async setEnrolledStudent({ commit }, payload) {
      await ApiV2.get(
        `departments/${payload.departmentId}/departmentEnrollments`,
        {
          params: {
            filter: {
              user_id: payload.studentId,
            },
          },
        }
      ).then((response) => {
        commit("setEnrolledStudent", response.data.data[0]);
      });
    },
  },
  modules: {},
});
